import React, { Component } from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import classnames from 'classnames';
import JqDatePicker from '../../lib/mxjslib/mx.react.jquery-ui.datepicker.min';


import {selectDate,selectNavMenu} from '../../actions';
import {Time} from '../../util';

class Filter extends Component {
  constructor(props){
    super(props);
    
    this.prevDayHandler = this.prevDayHandler.bind(this);
    this.nextDayHandler = this.nextDayHandler.bind(this);
    this.calendarOption = this.calendarOption.bind(this);
  }
  componentDidMount(){
    JqDatePicker.func('setDate', this.props.selectedDate);
  }
  componentWillReceiveProps(nextProps){
    if(this.props.selectedDate !== nextProps.selectedDate ){
      JqDatePicker.func('setDate', nextProps.selectedDate);
    }
  }
    
  dateUpdate(myDate){
    this.props.selectDate(myDate);
  }
  prevDayHandler(){
    const currentDateObj = moment(this.props.selectedDate);
    const prevDateObj = currentDateObj.add(-1, 'days');
    const prevDate = prevDateObj.format('YYYY-MM-DD');
    
    JqDatePicker.func('setDate', prevDate);
    document.querySelector('.hasDatepicker').value = prevDate;
    this.dateUpdate(prevDate);
  }
  nextDayHandler(){
    const currentDateObj = moment(this.props.selectedDate);
    const prevDateObj = currentDateObj.add(1, 'days');
    const nextDate = prevDateObj.format('YYYY-MM-DD');

    JqDatePicker.func('setDate', nextDate);
    document.querySelector('.hasDatepicker').value = nextDate;
    this.dateUpdate(nextDate);
  }
  calendarOption(){
    const options = {
      inline: true,
      yearSuffix: ' -',
      domType: 'input', //|| 'div', // def: div
      dateFormat: 'yy-mm-dd',
      dayNames: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      monthNames: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      monthNamesShort: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      showMonthAfterYear: true,
      defaultDate: Time.getAddDate(Time.getToday(), -1),//Time.getToday(),

      onSelect: (dateText) => {
        this.props.selectDate(dateText);
      }
    };
    return options;
  }
  render() {
    const {viewMode, selectedMenu, changeViewMode} = this.props;
    return (
      <div className='container filter'>
        <span className="filterPrev icon arrow-left" onClick={this.prevDayHandler}></span>
        <JqDatePicker {...this.calendarOption()} />
        <span className="filterNext icon arrow-right" onClick={this.nextDayHandler}></span>
        {/* 아리랑TV SCHEDULE TEXT-MODE & VIEW-MODE 사용안함 */}
        {/* {selectedMenu === "SCHEDULE" && 
          <div className="mode-flag">
            <div className={classnames("view-mode", {"visible": viewMode})} onClick={e=>changeViewMode('viewMode')}></div>
            <div className={classnames("text-mode", {"visible": !viewMode})} onClick={e=>changeViewMode('textMode')}></div>
          </div>
        } */}
      </div>
    );
  }
}
const mapDispatcherToProps = dispatch => {
  return {
    selectDate: (selectedDate) => dispatch(selectDate(selectedDate)),
  }
};

const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    selectedMenu: state.selectedMenu
  }
};

Filter = connect(mapStateToProps, mapDispatcherToProps)(Filter);
export default Filter;


// WEBPACK FOOTER //
// ./src/components/filter/Filter.js